export var FamilyRole;
(function (FamilyRole) {
    FamilyRole["FAMILY_MEMBER"] = "FAMILY_MEMBER";
    FamilyRole["FAMILY_LEADER"] = "FAMILY_LEADER";
    FamilyRole["FAMILY_GUEST"] = "FAMILY_GUEST";
})(FamilyRole || (FamilyRole = {}));
